export default "__VITE_ASSET__DgmaNL0O__"